/** BCP-47-ish path slug: en, en-GB, zh-Hant-TW (same shape as language middleware). */
export const LANG_SLUG_PATTERN = /^[a-z]{2}(?:-[a-z]{2,4}){0,2}$/i;

/** True when a path segment looks like a language slug. */
export const isLangSlug = (slug: string | undefined): boolean =>
    Boolean(slug && LANG_SLUG_PATTERN.test(slug));
